import {Timeline} from '@primer/react'
import {Blankslate} from '@primer/react/experimental'
import {CommentIcon} from '@primer/octicons-react'
import type {ReactNode} from 'react'
import type {TimelineItem} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {TimelineEvent} from './TimelineEvent'
import styles from './TimelinePanel.module.css'

export function TimelineItemList({
  items,
  clipSidebar,
  sentinel,
}: {
  items: TimelineItem[]
  clipSidebar?: boolean | 'start' | 'end'
  sentinel?: ReactNode
}) {
  if (items.length === 0 && !sentinel) {
    return (
      <div className={styles.emptyState}>
        <Blankslate>
          <Blankslate.Visual>
            <CommentIcon size={24} />
          </Blankslate.Visual>
          <Blankslate.Heading as="h4">No timeline events</Blankslate.Heading>
          <Blankslate.Description>Activity on this pull request will appear here.</Blankslate.Description>
        </Blankslate>
      </div>
    )
  }

  return (
    <Timeline clipSidebar={clipSidebar}>
      {items.map(item => (
        <TimelineEvent key={item.id} item={item} />
      ))}
      {sentinel}
    </Timeline>
  )
}
